

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { LogDataFormComponent } from './logdata-form/logdata-form.component';
import { LogDataComponent } from './logdata.component';
import { LogDataRoutes } from './logdata.routing';

export function declaration() {
    return [LogDataComponent, LogDataFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class LogDataModule {
}

@NgModule({
    imports: [LogDataModule, LogDataRoutes],
    exports: [LogDataModule]
})
export class LogDataWithRouteModule {
}
